import { createAction, props } from '@ngrx/store';

export const getRedemptions = createAction('[Redemptions] Get Redemptions', props<any>());
export const redemptionsFailure = createAction('redemptions-failed', props<any>());
export const redemptionsSuccess = createAction('redemptions-sucess', props<any>());
